module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.cart == 'VISA') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Help with your visa application file " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(">Help with your visa application file")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cart == 'CRRV') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(" Appeal to the Appeals Board on Visa Refusals " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(" Appeal to the Appeals Board on Visa Refusals.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cart == 'TA') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Appeal to the Administrative Court of Nantes " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Administrative Court of Nantes")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cart == 'PREMIUM') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Premium Pack " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("You are assisted and defended by a lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/lawyer.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onClickPay()
      }
    }
  }, [_c('span', [_vm._v("Payer")])])], 1), _vm._v(" "), _vm._m(4)])], 1) : _c('div', [_c('h2', [_vm._v("Payment received!")]), _vm._v(" "), (_vm.isFriendPay) ? _c('div', [_c('p', [_vm._v("A confirmation email has just been sent to your friend")]), _vm._v(" "), _c('p', [_vm._v("He/She can now continue the creation of your file")]), _vm._v(" "), _c('p', [_vm._v("We thank you for your help")])]) : _c('div', [_c('p', [_vm._v("A confirmation email has just been sent to you")]), _vm._v(" "), _c('p', [_vm._v("You can now continue the creation of your file.")]), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickContinue()
      }
    }
  }, [_vm._v("Continue")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "40%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/credit-card.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('h2', [_vm._v("Payment with an international credit card ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "margin": "0px 4px"
    },
    attrs: {
      "src": "/static/visa.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "48px",
      "margin": "0px 4px"
    },
    attrs: {
      "src": "/static/mastercard.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "48px",
      "margin": "0px 4px"
    },
    attrs: {
      "src": "/static/american-express.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "24px",
      "margin": "0px 4px"
    },
    attrs: {
      "src": "/static/locked.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child"
  }, [_c('div', {
    staticClass: "form-row",
    staticStyle: {
      "width": "80%",
      "min-width": "400px"
    }
  }, [_c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding": "16px 0px",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "40%",
      "max-width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/powered_by_stripe.svg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01957428","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutStripe.vue
// module id = 722
// module chunks = 3